import React from 'react'
import './Leaders.scss'
import humanFormat from 'human-format'
import { BigNumber } from 'ethers'

import { Leader1, Leader2, Leader3, GraeberLogo } from 'src/assets/images'
import { UserReward } from '../../models/UserReward'
import { formatAddress } from '../../utils/format/formatAddress'

interface IProps {
  first: UserReward
  second: UserReward
  third: UserReward
}

export function Leaders({ first, second, third }: IProps) {
  return (
    <div className="leaders">
      <Leader userReward={first} position="first" />
      <Leader userReward={second} position="second" />
      <Leader userReward={third} position="third" />
    </div>
  )
}

function Leader({
  userReward,
  position,
}: {
  userReward: UserReward
  position: 'first' | 'second' | 'third'
}) {
  let leaderImageToUse = Leader1

  if (position === 'second') {
    leaderImageToUse = Leader2
  } else if (position === 'third') {
    leaderImageToUse = Leader3
  }

  return (
    <div className="leader-user">
      <img className="leader-img" src={leaderImageToUse} />
      <div className="leader-user__leader-details">
        <img className="leader-user__img" src={GraeberLogo} />
        <div className="leader-text">
          <p className="leader-user__leader-earnings">
            {humanFormat(
              BigNumber.from(userReward.earned).div(BigNumber.from(10).pow(12)).toNumber(),
              { decimals: 1 },
            )}
          </p>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href={`https://etherscan.io/address/${userReward.user}`}
            className="leader-user__leader-address"
          >
            {formatAddress(userReward.user)}
          </a>
        </div>
      </div>
    </div>
  )
}
